module.exports = __webpack_public_path__ + "img/smallShadowMimi1.63228914.png";